import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import asderLogo from '../images/asderrLogo.png';

// const DEMO_ACCOUNTS = [
//   { rol: 'Kurucu', email: 'kurucu@dershanepro.com', sifre: 'Kurucu123!', color: '#C0392B' },
//   { rol: 'Öğrenci İşleri', email: 'ogrenci.isleri@dershanepro.com', sifre: 'Isleri123!', color: '#27AE60' },
//   { rol: 'Öğretmen', email: 'mat.ogretmen@dershanepro.com', sifre: 'Ogretmen123!', color: '#5B8DD4' },
//   { rol: 'Rehber', email: 'rehber@dershanepro.com', sifre: 'Rehber123!', color: '#9B72CF' },
//   { rol: 'Veli', email: 'veli1@gmail.com', sifre: 'Veli123!', color: '#D4853A' },
//   { rol: 'Öğrenci', email: 'emre.kurt@ogrenci.com', sifre: 'Ogrenci123!', color: '#3AACCF' },
//   { rol: 'muhasebe', email: 'muhasebe@dershanepro.com', sifre: 'Muhasebe123!', color: '#3AACCF' },
// ];

const DEMO_ACCOUNTS = [
  { rol: 'Kurucu', email: 'kurucu@dershanepro.com', sifre: 'Kurucu123!', color: '#C0392B' },
  { rol: 'Öğrenci İşleri', email: 'ogrenci.isleri@dershanepro.com', sifre: 'Isleri123!', color: '#27AE60' },
  { rol: 'Öğretmen', email: 'yusufaras@asdersistem.com', sifre: 'Kullanici123!', color: '#5B8DD4' },
  { rol: 'Rehber', email: 'sibelaydin@asdersistem.com', sifre: 'Kullanici123!', color: '#9B72CF' },
  { rol: 'Veli', email: 'hacihasancihanbilgin@asdersistem.com', sifre: 'hasancihanbilginveli', color: '#D4853A' },
  { rol: 'Öğrenci', email: '120001@asdersistem.com', sifre: 'hasan120001', color: '#3AACCF' },
  { rol: 'muhasebe', email: 'muhasebe@dershanepro.com', sifre: 'Muhasebe123!', color: '#3AACCF' },
];

const ROLE_REDIRECT = {
  kurucu: '/admin/dashboard',
  ogrenci_isleri: '/admin/dashboard',
  ogretmen: '/ogretmen/dashboard',
  rehber_ogretmen: '/rehber/dashboard',
  veli: '/veli/dashboard',
  ogrenci: '/ogrenci/dashboard',
  muhasebe: '/muhasebe/dashboard',
};

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = 'ASDER Sistem';
    return () => {
      document.title = prevTitle;
    };
  }, []);

  const handleLogin = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!email.trim() || !sifre.trim()) {
      toast.error('E-posta ve şifre gerekli');
      return;
    }
    setLoading(true);
    const result = await login(email.trim(), sifre);
    setLoading(false);
    if (result.success) {
      toast.success('Hoş geldiniz!');
      navigate(ROLE_REDIRECT[result.user?.rol] || '/admin/dashboard');
    } else {
      toast.error(result.message || 'Giriş başarısız');
    }
  };

  const selectDemo = (acc) => {
    setEmail(acc.email);
    setSifre(acc.sifre);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      position: 'relative',
      overflowX: 'hidden',
    }}>
      {/* BG glow effects */}
      <div style={{ position: 'absolute', top: '-15%', left: '-8%', width: isMobile ? '80vw' : '55vw', height: isMobile ? '80vw' : '55vw', background: 'radial-gradient(circle, rgba(192,57,43,0.07) 0%, transparent 65%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-10%', right: '-5%', width: isMobile ? '60vw' : '35vw', height: isMobile ? '60vw' : '35vw', background: 'radial-gradient(circle, rgba(192,57,43,0.04) 0%, transparent 65%)', pointerEvents: 'none' }} />

      {/* ── Left Branding Panel (sadece PC) ── */}
      {!isMobile && (
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '60px',
          borderRight: '1px solid var(--border)',
          background: 'linear-gradient(160deg, var(--bg-surface) 0%, var(--bg-base) 100%)',
          animation: 'fadeInUp 0.6s ease both',
        }}>
          <div style={{ maxWidth: 440 }}>
            {/* Logo */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 52 }}>
              <div style={{
                width: 180,
                height: 180,
                background: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.1))',
              }}>
                <img src={asderLogo} alt="Asder Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <div>
                <div style={{
                  fontFamily: 'var(--font-ui)',
                  fontWeight: 800,
                  fontSize: '1.8rem',
                  color: 'var(--text-blue)',
                  letterSpacing: '-0.01em',
                  lineHeight: 1.1
                }}>
                  ASDER Sistem
                </div>
                <div style={{
                  fontSize: '0.75rem',
                  color: 'var(--text-muted)',
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                  marginTop: 4
                }}>
                  Akademik Yönetim Sistemi
                </div>
              </div>
            </div>

            <h1 style={{ marginBottom: 16, fontSize: '2.4rem', lineHeight: 1.15, color: 'var(--text-blue)', fontFamily: 'var(--font-ui)' }}>
              Öğrencilerin<br />
              <span style={{ color: 'var(--accent)', fontStyle: 'italic' }}>başarısı</span> için
            </h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: 1.75, marginBottom: 44 }}>
              Yoklama, deneme analizi, rehberlik görüşmeleri ve daha fazlası —
              tüm yönetim araçları tek platformda.
            </p>

            {/* Stats row */}
            <div style={{ display: 'flex', gap: 28 }}>
              {[['7', 'Rol'], ['60+', 'API'], ['∞', 'Öğrenci']].map(([n, l], i) => (
                <div key={i} style={{ animation: `fadeInUp 0.5s ease ${i * 100 + 400}ms both` }}>
                  <div style={{ fontFamily: 'var(--font-ui)', fontSize: '1.9rem', fontWeight: 800, color: 'var(--accent)', lineHeight: 1 }}>{n}</div>
                  <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: 3, fontWeight: 500 }}>{l}</div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 28, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {[
                { t: 'Canlı Takip', d: 'Yoklama, ödev ve deneme süreçlerini tek ekranda takip edin.' },
                { t: 'Hızlı Karar', d: 'Ölçme sonuçlarıyla doğru öğrencide doğru aksiyonu alın.' },
              ].map((item, idx) => (
                <div key={idx} style={{
                  border: '1px solid var(--border)',
                  background: 'rgba(255,255,255,0.5)',
                  borderRadius: 'var(--r-md)',
                  padding: '10px 12px',
                }}>
                  <div style={{ fontSize: '0.8rem', fontWeight: 800, color: 'var(--text-blue)', marginBottom: 4 }}>{item.t}</div>
                  <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', lineHeight: 1.45 }}>{item.d}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── Right Login Panel ── */}
      <div style={{
        width: isMobile ? '100%' : 460,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isMobile ? 'flex-start' : 'center',
        padding: isMobile ? '32px 24px 48px 24px' : '48px 44px',
        background: 'var(--bg-surface)',
        animation: isMobile ? 'fadeInUp 0.5s ease both' : 'slideInRight 0.5s ease both',
      }}>

        {/* ── Mobil Logo Başlık (sadece mobilde) ── */}
        {isMobile && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            marginBottom: 28,
            paddingBottom: 24,
            borderBottom: '1px solid var(--border)',
          }}>
            <div style={{
              width: 52,
              height: 52,
              background: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.1))',
            }}>
              <img src={asderLogo} alt="Asder Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
            </div>
            <div>
              <div style={{
                fontFamily: 'var(--font-ui)',
                fontWeight: 800,
                fontSize: '1.2rem',
                color: 'var(--text-blue)',
                letterSpacing: '-0.01em',
                lineHeight: 1.1,
              }}>
                ASDER Sistem
              </div>
              <div style={{
                fontSize: '0.65rem',
                color: 'var(--text-muted)',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginTop: 3,
              }}>
                Akademik Yönetim Sistemi
              </div>
            </div>
          </div>
        )}

        <div style={{ maxWidth: 440, margin: isMobile ? '0 auto' : '0', width: '100%' }}>
          <div style={{ marginBottom: 24 }}>
            <h2 style={{ marginBottom: 6, fontFamily: 'var(--font-ui)' }}>Giriş Yap</h2>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>Hesabınıza erişmek için bilgilerinizi girin</p>
          </div>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <div className="form-group">
              <label className="form-label">E-posta</label>
              <input
                type="email"
                className="form-input"
                placeholder="ornek@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Şifre</label>
              <input
                type="password"
                className="form-input"
                placeholder="••••••••"
                value={sifre}
                onChange={e => setSifre(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}
              disabled={loading}
            >
              {loading ? (
                <><div className="spinner" style={{ width: 15, height: 15 }} />&nbsp;Giriş yapılıyor...</>
              ) : 'Giriş Yap →'}
            </button>
          </form>

          {/* Demo accounts */}
          {/* <div style={{ marginTop: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
              <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
              <span style={{ fontSize: '0.7rem', color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>Demo Hesapları</span>
              <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              {DEMO_ACCOUNTS.map((acc, i) => {
                const isSelected = email === acc.email;
                return (
                  <button
                    key={i}
                    type="button"
                    onClick={() => selectDemo(acc)}
                    style={{
                      background: isSelected ? `${acc.color}18` : 'var(--bg-input)',
                      border: `1px solid ${isSelected ? acc.color + '50' : 'var(--border-strong)'}`,
                      borderRadius: 'var(--r-md)',
                      padding: '9px 12px',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'all 0.15s',
                      display: 'flex', alignItems: 'center', gap: 8,
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.borderColor = acc.color + '60';
                      e.currentTarget.style.background = acc.color + '12';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.borderColor = isSelected ? acc.color + '50' : 'var(--border-strong)';
                      e.currentTarget.style.background = isSelected ? `${acc.color}18` : 'var(--bg-input)';
                    }}
                  >
                    <div style={{ width: 8, height: 8, borderRadius: '50%', background: acc.color, flexShrink: 0 }} />
                    <span style={{ fontSize: '0.78rem', fontWeight: 600, color: isSelected ? 'var(--text-primary)' : 'var(--text-secondary)' }}>{acc.rol}</span>
                  </button>
                );
              })}
            </div>

            {email && sifre && (
              <button
                type="button"
                className="btn btn-outline"
                style={{ width: '100%', justifyContent: 'center', marginTop: 10, fontSize: '0.82rem' }}
                onClick={handleLogin}
                disabled={loading}
              >
                Seçilen demo ile giriş yap →
              </button>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
}